import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import CustomBackdrop from '../../../../components/backdrop';
import getEnvironement from '../../../../environnement';
import CustomInput from '../../../../components/customInput';

export default function AddDialog({
  open,
  handleOpen,
  handleClose,
  reloadData,
}) {
  const [commentaire, setCommentaire] = useState('');
  const [commentaireEn, setCommentaireEn] = useState('');
  const [commentaireError, setCommentaireError] = useState('');
  const [commentaireEnError, setCommentaireEnError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function addCommentaire() {
    const url = `${getEnvironement().API_URL}/commentaires`;
    const data = {
      commentaire,
      commentaireEn
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => reloadData())
      .then(() => setTimeout(() => toast.success('Le commentaire a bien été ajouté'), 800))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.commentaire ? setCommentaireError(err.response.data.errors.commentaire[0]) : setCommentaireError('');
          err.response.data.errors.commentaireEn ? setCommentaireEnError(err.response.data.errors.commentaireEn[0]) : setCommentaireEnError('');
          handleOpen();
        }
      });
  }

  useEffect(() => {
    setCommentaire('');
    setCommentaireEn('');
    if (!open) {
      setCommentaireError('');
      setCommentaireEnError('');
    }
  }, [open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Ajouter un commentaire :</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomInput
              type='textarea'
              placeholder='Commentaire'
              value={commentaire}
              setValue={setCommentaire}
              isError={commentaireError !== ''}
              error={commentaireError}
            />
            <CustomInput
              type='textarea'
              placeholder='Commentaire (anglais)'
              value={commentaireEn}
              setValue={setCommentaireEn}
              isError={commentaireEnError !== ''}
              error={commentaireEnError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={addCommentaire}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Ajouter</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
